// extracted by mini-css-extract-plugin
export const iconList = "teamsection-module--iconList--1vor9";